import { getAPIURL } from '../../GlobalComponents/URLs'

export type SalesTeam = {
    Team: string
}

export type SalesReportGroup = {
    Team: string
    ReportGroup: string
}

export type SalesReportArea = {
    Team: string
    ReportGroup: string
    ReportArea: string
}

export type SalesDivision = {
    Team: string
    ReportGroup: string
    ReportArea: string
    Division: string
}

export type Salesperson = {
    SalespersonCode: string
    SalespersonName: string
    SalespersonCodeName: string
}

export type FetchSalesGroupsReturnPayload = {
    IncomeStatementGroups: Array<SalesDivision>
    SalesPerson: Array<Salesperson>
}

export const fetchSalesGroups = async (): Promise<FetchSalesGroupsReturnPayload> => {
    let url = `${getAPIURL()}salesperson/salesgroups`

    let req = await fetch(url, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    })
    let json: FetchSalesGroupsReturnPayload = await req.json()
    return json
}
